/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UpdatedFieldName = {
    JobTitle: 'JOB_TITLE',
    Category: 'CATEGORY',
    InitialCategory: 'INITIAL_CATEGORY',
    Experience: 'EXPERIENCE',
    DailyRate: 'DAILY_RATE',
    WorkConditions: 'WORK_CONDITIONS',
    WorkConditionsAndDuration: 'WORK_CONDITIONS_AND_DURATION',
    FormerCompany: 'FORMER_COMPANY',
    BusinessSector: 'BUSINESS_SECTOR',
    Keyword: 'KEYWORD',
    ProjectTitle: 'PROJECT_TITLE',
    ChosenProjectDescription: 'CHOSEN_PROJECT_DESCRIPTION',
    InferredProjectDescription: 'INFERRED_PROJECT_DESCRIPTION',
    OriginalProjectDescription: 'ORIGINAL_PROJECT_DESCRIPTION',
    Language: 'LANGUAGE',
    Skill: 'SKILL',
    StartDate: 'START_DATE',
    Duration: 'DURATION',
    ExpectedSourcingProcess: 'EXPECTED_SOURCING_PROCESS',
    RefinementCriterion: 'REFINEMENT_CRITERION'
} as const;
export type UpdatedFieldName = typeof UpdatedFieldName[keyof typeof UpdatedFieldName];


export function instanceOfUpdatedFieldName(value: any): boolean {
    for (const key in UpdatedFieldName) {
        if (Object.prototype.hasOwnProperty.call(UpdatedFieldName, key)) {
            // @ts-ignore
            if (UpdatedFieldName[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UpdatedFieldNameFromJSON(json: any): UpdatedFieldName {
    return UpdatedFieldNameFromJSONTyped(json, false);
}

export function UpdatedFieldNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedFieldName {
    return json as UpdatedFieldName;
}

export function UpdatedFieldNameToJSON(value?: UpdatedFieldName | null): any {
    return value as any;
}

